export default defineNuxtPlugin(nuxtApp => {
  const { frogoApiKey } = useRuntimeConfig().public;

  if (!frogoApiKey) return;

  const scriptSrc = import.meta.dev ? 'aHR0cHM6Ly9mcy5wdWRhZi5uZXQvZnAuanM=' : 'aHR0cHM6Ly9mcy5wdWRhZi5jb20vZnAuanM=';

  const beParam = import.meta.dev ? 'aHR0cHM6Ly9mLnB1ZGFmLm5ldA==' : 'aHR0cHM6Ly9mLnB1ZGFmLmNvbQ==';

  const script = document.createElement('script');

  script.innerHTML = `
    (function(a,w,d,t,s,b,e,m){
      w['afto']=a;
      w[a]=w[a]||function(k,v){w[a].q[k]=v||1;};
      w[a].q={be:b};
      e=d.createElement(t);
      m=d.getElementsByTagName(t)[0];
      e.async=1;
      e.src=atob(s);
      m.parentNode.insertBefore(e,m);
    })('aft',window,document,'script','${scriptSrc}','${beParam}');
    aft('apiKey','${frogoApiKey}');
    aft('manual');
    aft('start');
    aft('send');
  `;

  document.head.appendChild(script);
});
